import { Back } from "./back";

export const PrivacyPolicy = () => {
  return (
    <>
      <Back />
      <div className="legal">
        <h1> Privacy Policy </h1>
        Your privacy is very important to us. This privacy policy describes how
        Offsett (“we”) collect, use, and disclose information when you interact
        with our website.
        <h2>Data we collect</h2>
        <h3>Personal information</h3>
        Personal information means data that can be used to identify you. This
        data is either collected automatically or provided voluntarily by you.
        <h3>Anonymized data</h3>
        Anonymized data is data that cannot be used to reveal your identity
        (directly or indirectly). We will possibly store personal data
        indefinitely long. This consists of
        <ul>
          <li>
            device data: includes information about the device you used to
            interact with our services
          </li>
          <li>location data: includes geolocation based on IP address</li>
          <li>log and usage data: includes usage and performance info</li>
        </ul>
        <h2>How we collect your personal information</h2>
        We only collect and use your personal information when we have
        legitimate reasons. In this case, we will collect and store your
        personal information in a transparent, lawful, and fair manner.
        <h2>How we use your personal information</h2>
        Offsett may use your personal data for the following purposes:
        <ul>
          <li>To provide our service</li>
          <li>To contact you</li>
        </ul>
        <h2>How we store your personal information</h2>
        <h3>Personal information retention</h3>
        Offsett will only hold your personal information for as long as we have
        to, to provide our service, or to comply with legal obligations. After
        that, we will either delete your personal data or anonymize it cannot be
        used to identify your identity.
        <h2>Security of your personal information</h2>
        We maintain technical and organizational measures to protect your
        personal data against unauthorized access and deletion. However, no data
        storage system can be 100% secure. If you believe your data is no longer
        secure please contact us as soon as possible.
        <h2>Third-party services</h2>
        We use third-party data processors to improve our services. Some of your
        personal information might be shared with third parties. We make sure
        your personal information is safe and we carefully select the
        third-party providers we cooperate with. We only share data that is
        needed for them to run their service.
        <h2>Your rights and choices</h2>
        <h3>Access</h3>
        You can request access to all the data we hold on you.
        <h3>Rectification</h3>
        If you believe that any information we hold on you is inaccurate,
        incomplete or outdated, you can request to update it.
        <h3>Deletion</h3>
        Under certain conditions, you can request that we erase parts of your
        data or all of the data we hold on you.
        <h3>Portability</h3>
        Under certain conditions, you can request a copy of the personal
        information we hold about you. You can also request that we transfer
        your personal information to a third party.
        <h3>Data restriction</h3>
        Under certain conditions, you can request that we restrict the
        processing of personal data we hold on you. This means that we are
        allowed to store your personal data but are not allowed to use it.
        <h3>Objection to processing</h3>
        Under certain conditions, you can object to us processing your personal
        data.
        <h3>Unsubscribe</h3>
        You can unsubscribe from any nonessential email communication (e.g.
        marketing) at any time. You can either click the unsubscribe button at
        the bottom of the email or send us an email.
        <h2>Used by children below age 16</h2>
        We don’t collect personal information about children below the age of 16
        knowingly. If we (or you) become aware that we store information about
        children below age 16, we will have to delete this information.
        <h2>Links to other websites</h2>
        Our website contains links to other websites and services not run by
        Offsett. These companies have a different privacy policy than we do. We
        highly recommend you to read their privacy policies. We are not
        responsible for how these websites handle your data.
        <h2>Business transfers / Mergers and Acquisitions</h2>
        If Offsett is involved in a merger, acquisition or asset sale, personal
        data we hold about you may be transferred. We will inform you before
        your personal data is transferred. After that, your personal data will
        be subject to a different privacy policy.
        <h2>Updates to this privacy policy</h2>
        We are regularly reviewing our privacy policy to ensure that it meets
        all legal requirements and industry best practices. This privacy policy
        was last updated on 12.09.2021
        <h2>Contact us</h2>
        In case you have suggestions, questions, complaints or simply want to
        know more about the personal information we hold on you, send us an
        email to hello@offsett.co or write a letter to Christian Wallenwein at
        Willi-Graf Straße 17, Room 718, 80805 Munich, Germany
        {/* </Modal> */}
      </div>
    </>
  );
};
